// src/PublicUser/pages/FreeCertificatesPage.jsx
import React from 'react';
import FreeCertificates from '../components/FreeCertificates/FreeCertificates';

const FreeCertificatesPage = () => {
  return <FreeCertificates />;
};

export default FreeCertificatesPage;